<template>
<div>
  <!-- TEST> {{localSelectedContact}} -->

  <a class="button is-light"  @click="addChannelTop" :disabled="!localSelectedContact">
    <div>  
      <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
    </div>
    NEW Channel
  </a>

  <!-- ADMIN BUTTON -->
  <a class="button is-light" @click.prevent="toggleEdit" v-if="isAdmin" :disabled="!localSelectedContact || (localSelectedContact  && localSelectedContact.channels.length==0)">
    <i class="fas fa-cog" style="color: green; font-size:1.8em;" v-if="isAdmin" ></i>
  </a>

  <!-- .. NOTIFICATION  -->
  <b-notification :closable="false" v-if="!localSelectedContact" style="padding: 20px;margin: 10px;">
      No Contact selected!
  </b-notification>

  

<!-- <div  v-if="localSelectedContact && localSelectedContact.channels.length>0"> -->
<div  v-if="localSelectedContact">
  

  
  <!-- .. NOTIFICATION  -->
  <b-notification :closable="false" v-if="localSelectedContact && localSelectedContact.channels.length==0" style="padding: 20px;margin: 10px;">
      No Existing Channels!
      <!-- <b-loading :is-full-page="true" :active.sync="!localSelectedContact" :can-cancel="true"></b-loading> -->
  </b-notification>

  <!-- <div class="buttons has-addons is-right">
    <a class="button is-light"  @click="addChannel">
      <div>  
        <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
      </div>
      NEW
    </a>
    <button type="button" aria-label="edit" @click.prevent="toggleEdit">
      
      <i class="fas fa-cog" style="font-size:1.8em;" v-if="isAdmin" ></i>
    </button>
  </div> 
  --> 

<section class="section">
  <div style="margin-bottom: 1em;">
    <div v-for="(channel, index) in localSelectedContact.channels" v-bind:key="index">
      <!-- {{channel}} -->
      <ListPanelChannelItem v-if="channel" :channel='channel' style="margin-bottom: 0.5em;"/>

      <button v-if="isEditActive"  type="button" style="margin-bottom: 1.5em;" aria-label="delete" @click.prevent="triggerDeleteChannel(index)">
        <!-- <i class="fas fa-chevron-circle-down" style="font-size:1.8em;" v-if="!isEditActive" ></i> -->
        <i class="fas fa-trash" style="font-size:1.8em;" ></i>
      </button>

    </div>
  </div>

</section>

  <div v-if="this.localSelectedContact && this.localSelectedContact.channels.length>0">
  <!-- <div> -->
    <a class="button is-light"  @click="addChannel">
      <div>  
        <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
      </div>
      NEW
    </a>
    <a class="button is-light"  @click="saveContact">
      <div>  
        <i class="fas fa-save" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
      </div>
      SAVE
    </a>
  </div>

<!-- 
  <div v-for="channel in contacts[selected].channels" v-bind:key="channel.type">
    <ListPanelChannelItem :channel='channel' style="margin-bottom: 1em;"/>
  </div> 
  -->

</div>
</div>
</template>

<script>
import ListPanelChannelItem from '@/components/main/contact/ListPanelChannelItem.vue';
import { mapGetters, mapActions } from 'vuex';


export default {
  

  name: 'ListPanelChannel',
  components: {
    ListPanelChannelItem
  },
  props: [
    'localSelectedContact',
  ],
  data() {
    return  {
      isEditActive: false,
      isAdmin: true,
      // localSelectedContact: this.propSelectedContact,
    }
  },
  created () {
    // this.localSelectedContact = JSON.parse(JSON.stringify(this.selectedContact))
    // this.localSelectedContact = this.selectedContact
  },
  computed: {
    ...mapGetters(['selectedContact']), //'selectedContact'  //..not listening here, 
  },
  methods: {
    ...mapActions(['updateContact', 'deleteChannel']),
    addChannel () {
      this.localSelectedContact.channels.push(
        {type: null, info: '', atags: [], tags: [], pref: false} 
        )
    },
    addChannelTop () {
      this.localSelectedContact.channels.unshift(
        {type: null, info: '', atags: [], tags: [], pref: false} 
        )
    },
    saveContact() {
      this.updateContact(this.localSelectedContact)
    },
    triggerDeleteChannel( index ) {
      // this.deleteChannel(index)
      this.localSelectedContact.channels.splice(index, 1)
      // this.updateContact(this.localSelectedContact)
      //.. just local .. NEED TO BE SAVED TO BE PERSISTED!
    },
    toggleEdit() {
      this.isEditActive = !this.isEditActive
    }
    // clickMe () {
    //   window.alert(this.msg)
    // }
  },
  watch: {
    // selectedContact (newVal) {
    //   this.localSelectedContact = JSON.parse(JSON.stringify(newValue))
    //   // this.localSelectedContact = newVal
    // }
  }
  // watch: {
  //   // selectedContact (newValue, oldValue) {
  //   selectedContact (newValue) {
  //     // console.log(`Updating from ${oldValue} to ${newValue}`);
  //     // console.log(`Updating  ${JSON.stringify(newValue)}`);
  //     this.localSelectedContact = JSON.parse(JSON.stringify(newValue))  //..making a copy (by parsing JSON )
  //     // this.localSelectedContact = Object.assign({}, newValue)   //...make a copy of the object (even working with the original Object, it's needed) !!! important to make it reactive !!!???
  //   }
  // },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.section {
  margin: 10px;
  padding : 10px;
}

</style>